import Base from "emun.customer/customer-dashboard-header.controller";

export const dealerVendorFields = {
  //priceList: "Price List",
  carrier: "Carrier",
  paymentTerm: "Payment Terms",
  salesRep: "Sales Rep",
};
export const vendorFields = Object.assign(
  {
    priceList: "Price List",
  },
  dealerVendorFields
);
export const vendors = {
  HFC: "Hooker",
  SM: "HF Custom",
  BY: "Bradington Young",
  SSW: "Sunset West",
};

export default class CustomerDashboardHeaderController extends Base {
  constructor() {
    super();
    Object.assign(this, {
      vendorFields: this.$session.isRepOrAbove()
        ? vendorFields
        : dealerVendorFields,
      vendors,
    });
  }
}
